var watchlistPositionAdd = {
	title: "Add position",
	subtitle: "Watchlist: {value}",
	noSelectedPositions: "Currently, there are no positions selected to add to the watchlist.",
	singleSelectedPosition: "There is 1 position selected to add to the watchlist.",
	multipleSelectedPositions: "There are {value} positions selected to add to the watchlist.",
	submit: "Ok",
	cancel: "Cancel",
	remove: "Remove",
	validationErrors: {
		positionExists: "Your selection is already on your watchlist"
	},
	noWatchlists: {
		title: "Info",
		message: "No watchlist has been created yet."
	}
};
var en = {
	watchlistPositionAdd: watchlistPositionAdd
};

export { en as default, watchlistPositionAdd };
